import { authRoles } from 'app/auth';
import MeasurementEditForm from './editform/MeasurementEditForm';
import MeasurementTable from './table/MeasurementTable';

export default [
	{
		path: '/measurement/edit/:id',
		component: MeasurementEditForm,
		auth: authRoles.measurement
	},
	{
		path: '/measurement/stream/:id',
		component: () => <MeasurementEditForm type="stream" />,
		auth: authRoles.measurement
	},
	{
		path: '/measurement/record/:id',
		component: () => <MeasurementEditForm type="record" />,
		auth: authRoles.measurement
	},
	{
		path: '/measurement/:sessionNameParam?',
		component: MeasurementTable,
		auth: authRoles.measurement
	}
];
